var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { Component } from "react";
import * as PropTypes from "prop-types";
import history from "@irati/utils/history";
import Loading from "@irati/ui/src/Loading";
import RewardService from "@irati/reward/apollo/Reward";
import { rewardTracking } from "@irati-tracking/reward";
import { hangPromise } from "@irati/utils/promise";
import ErrorText from "@irati/ui/src/ErrorText";
import RecognitionService from "@irati/recognition/services/Recognition";
import { injectIntl } from "@irati/utils/lang";
var CompletePayment = /** @class */ (function (_super) {
    __extends(CompletePayment, _super);
    function CompletePayment() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            completingPayment: hangPromise(),
            error: null
        };
        _this.getTrackingInfos = function () { return __awaiter(_this, void 0, void 0, function () {
            var rewardOrderId, rewardOrder;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        rewardOrderId = this.props.match.params.rewardOrderId;
                        return [4 /*yield*/, RewardService.getRewardOrder(rewardOrderId)];
                    case 1:
                        rewardOrder = _a.sent();
                        return [2 /*return*/, {
                                recipientsCount: rewardOrder.recipients.results.length,
                                costTotal: rewardOrder.costTotal,
                                rewardHeader: rewardOrder.reward.header
                            }];
                }
            });
        }); };
        return _this;
    }
    CompletePayment.prototype.componentDidMount = function () {
        var _this = this;
        var formatMessage = this.props.formatMessage;
        var _a = this.props.match.params, rewardOrderId = _a.rewardOrderId, entityId = _a.entityId, entityType = _a.entityType;
        var completingPayment = RewardService.confirmRewardPaymentOrder(rewardOrderId)
            .then(function () {
            if (entityId && entityType === "poll") {
                return RecognitionService.updatePollWithRewardId(entityId, rewardOrderId);
            }
            return RecognitionService.updateRecognitionWithRewardId(entityId, rewardOrderId);
        })
            .then(function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, recipientsCount, costTotal, rewardHeader;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.getTrackingInfos()];
                    case 1:
                        _a = _b.sent(), recipientsCount = _a.recipientsCount, costTotal = _a.costTotal, rewardHeader = _a.rewardHeader;
                        rewardTracking.rewardsTabAddRewardSuccess(recipientsCount, costTotal, rewardHeader);
                        history.push({ pathname: "/reward/success/" + rewardOrderId }, this.context);
                        return [2 /*return*/];
                }
            });
        }); })
            .catch(function () {
            _this.setState({ error: formatMessage({ id: "reward.genericPaymentError" }) });
        });
        this.setState({ completingPayment: completingPayment });
    };
    CompletePayment.prototype.render = function () {
        var _a = this.state, completingPayment = _a.completingPayment, error = _a.error;
        return React.createElement(Loading, { load: completingPayment }, error && React.createElement(ErrorText, null, error));
    };
    CompletePayment.contextTypes = {
        appPath: PropTypes.string.isRequired
    };
    return CompletePayment;
}(Component));
export default injectIntl(CompletePayment);
